<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);margin: 0 20px;overflow-y: auto">
      <div style="height: 100%">
        <div style="height: 50px">
          <el-button type="primary" plain icon="el-icon-plus" @click="addAccount()">新建账号</el-button>&nbsp;
          <el-input prefix-icon="el-icon-search" placeholder="输入用户名搜索" v-model="searchKeyword" clearable style="width: 300px"></el-input>
        </div>
        <div style="max-height: calc(100% - 100px);overflow-y: auto">
          <el-table :data="tbdata" v-loading="loading" element-loading-text="加载中，请耐心等待。"
            border style="width: 100%" highlight-current-row ref="singleTable">
            <el-table-column
              type="index"
              label="序号"
              width="100"
            align="center">
            </el-table-column>
            <el-table-column
              prop="username"
              label="用户名"
              min-width="80"
              align="center">
            </el-table-column>
            <el-table-column
              label="所属人员"
              min-width="100"
              align="center">
              <template slot-scope="scope">
                <span>{{getPersonName(scope.row)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="权限"
              min-width="80"
              align="center">
              <template slot-scope="scope">
                <span>{{getRole(scope.row)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="$store.state.user.moduletag !== 2"
              label="客服分组"
              min-width="80"
              align="center">
              <template slot-scope="scope">
                <span>{{getcustomerservicetag(scope.row.customerservicetag)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="$store.state.user.moduletag !== 2"
              label="模块"
              min-width="80"
              align="center">
              <template slot-scope="scope">
                <span>{{getmoduletag(scope.row.moduletag)}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="140">
              <template slot-scope="scope">
                <i title="修改密码" class="el-icon-key" style="cursor: pointer; font-size: 18px;color: blue" @click="changePwd(scope.row)"></i>
                <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editAccount(scope.row)"></i>
                <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delAccount(scope.row)"></i>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-top: 10px;height: 40px;text-align: center">
          <el-pagination v-fixZoom
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCells">
          </el-pagination>
        </div>
      </div>
    </div>
    <!--created-->
    <el-dialog :visible.sync="addShow" v-if="addShow" width="500px" :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div> <span>新建账号</span> </div>
        <div class="line-title"></div>
      </div>
      <account-add :accountAddRow="addRow" v-model="addShow"></account-add>
    </el-dialog>
    <!--update-->
    <el-dialog :visible.sync="editShow" v-if="editShow" width="500px" :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div> <span>更新账号</span> </div>
        <div class="line-title"></div>
      </div>
      <account-edit :accountEditRow="editRow" v-model="editShow"></account-edit>
    </el-dialog>
    <el-dialog :visible.sync="editPwdShow" v-if="editPwdShow" width="500px" :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div> <span>修改账号密码</span> </div>
        <div class="line-title"></div>
      </div>
      <div style="margin: 10px 40px 0px">
        <el-form style="margin-right: 30px" :model="pwdForm" :rules="pwdRules" ref="pwdForm" label-width="110px" class="demo-ruleForm">
          <el-form-item label="旧账号密码" prop="oldpwd">
            <el-input type="password" v-model="pwdForm.oldpwd" placeholder="请输入旧账号密码"></el-input>
          </el-form-item>
          <el-form-item label="新账号密码" prop="password">
            <el-input type="password" v-model="pwdForm.password" placeholder="请输入新账号密码"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="margin-top: 30px">
        <el-row style="margin: 0 40px">
          <el-col :span="12">
            <div class="cancel-btn" @click="editPwdShow = false">
              <span>取消</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="commitPwd('pwdForm')">
              <span>确定</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="height: 30px"></div>
    </el-dialog>
  </div>
</template>

<script>
import accountAdd from './childComponents/accountAdd'
import accountEdit from './childComponents/accountEdit'
import {queryorgperson} from '../../api/orguser'
import {queryuser, deleteuser, changepwd} from '../../api/account'
import {querysupplierorgperson} from '../../api/serviceMark'
// import bindSip from './childComponents/bindSip'
// import {querysip} from '../../api/sipPhone'
export default {
  name: 'account',
  components: {accountAdd, accountEdit},
  data () {
    return {
      // sip: [],
      // sipShow: false,
      // rowSip: {
      //   sips: [],
      //   row: ''
      // },
      loading: false,
      persons: [],
      supplierorgpersons: [],
      searchKeyword: '',
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      addShow: false,
      addRow: {
        persons: [],
        supplierorgpersons: []
      },
      editShow: false,
      editRow: {
        persons: [],
        supplierorgpersons: [],
        row: {}
      },
      editPwdShow: false,
      pwdForm: {
        oldpwd: '',
        password: '',
        spid: ''
      },
      pwdRules: {
        oldpwd: [
          { required: true, message: '请输入旧账号密码', trigger: 'blur' },
          { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入新账号密码', trigger: 'blur' },
          { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.golobleObject.updateTableAcc = this.getAccountTable
    this.getPersons()
  },
  mounted () {
  },
  computed: {
    tbdata () {
      return this.searchFilterWord()
    }
  },
  methods: {
    // sipPhoneData () {
    //   querysip().then(res => {
    //     this.sip = res.data.orgsips
    //     this.rowSip.sips = this.sip
    //     this.getPersons()
    //   }).catch(() => {})
    // },
    // 平台人员
    getPersons () {
      this.loading = true
      queryorgperson().then(res => {
        this.persons = res.data.orgpersons
        this.editRow.persons = this.persons
        this.addRow.persons = this.persons
        this.querySupplierPerson()
      }).catch(() => {
        this.loading = false
      })
    },
    // 服务商人员
    querySupplierPerson () {
      querysupplierorgperson().then(res => {
        this.supplierorgpersons = res.data.supplierorgpersons
        this.addRow.supplierorgpersons = res.data.supplierorgpersons
        this.editRow.supplierorgpersons = res.data.supplierorgpersons
        this.getAccountTable()
      }).catch(() => {})
    },
    // 表格
    getAccountTable () {
      this.loading = true
      queryuser().then(res => {
        let isTime = res.data.users.length / this.pageSize
        if (isTime !== parseInt(isTime)) {
          isTime = parseInt(isTime) + 1
        }
        if (isTime < this.currentPage) {
          if (this.currentPage !== 1) {
            this.currentPage -= 1
          }
        }
        this.loading = false
        this.tableData = res.data.users
      }).catch(() => {
        this.loading = false
      })
    },
    // table数据入口（tbdata）
    searchFilterWord () {
      const data = this.tableData
      const vm = this
      const search = data.filter((val) => {
        if (val.username.includes(vm.searchKeyword)) {
          return true
        }
      })
      vm.totalCells = search.length
      const arr = []
      for (let i = (vm.currentPage - 1) * vm.pageSize; i < vm.currentPage * vm.pageSize; i++) {
        if (!search[i]) {
          break
        }
        arr.push(search[i])
      }
      return arr
    },
    getRole (row) {
      let moduletag = this.$store.state.user.moduletag
      if (moduletag === 2) { // 机构
        // { value: 'admin', label: '管理员' },
        // { value: 'csd', label: '值班员' },
        // { value: 'guest', label: '护工' }
        if (row.role === 'superadmin') {
          return '超级管理者'
        } else if (row.role === 'admin') {
          return '管理者'
        } else if (row.role === 'csd') {
          return '值班员'
        } else if (row.role === 'guest') {
          return '护工'
        } else {
          return row.role
        }
      } else {
        if (row.role === 'superadmin') {
          return '超级管理者'
        } else if (row.role === 'admin') {
          return '管理者'
        } else if (row.role === 'op') {
          return '运营'
        } else if (row.role === 'csd') {
          return '客服'
        } else if (row.role === 'guest') {
          return '访客'
        } else if (row.role === 'company') {
          return '服务商'
        } else if (row.role === 'sv') {
          return '监管'
        } else {
          return row.role
        }
      }
    },
    getcustomerservicetag (tag) {
      if (tag === 1) {
        return '话务'
      } else if (tag === 2) {
        return '计生'
      } else if (tag === 3) {
        return '外勤'
      } else if (tag === 4) {
        return '话务/外勤'
      } else {
        return '-'
      }
    },
    getmoduletag (moduletag) {
      let name = ''
      if (moduletag === 3) {
        name = '居家，机构'
      } else if (moduletag === 2) {
        name = '机构'
      } else if (moduletag === 1) {
        name = '居家'
      }
      return name
    },
    getPersonName (row) {
      if (row.spid !== '0') {
        for (let i = 0; i < this.persons.length; i++) {
          if (parseInt(row.spid) === parseInt(this.persons[i].id)) {
            return this.persons[i].name
          }
        }
      }
      if (row.supplier_pid !== '0') {
        for (let i = 0; i < this.supplierorgpersons.length; i++) {
          if (parseInt(row.supplier_pid) === parseInt(this.supplierorgpersons[i].id)) {
            return this.supplierorgpersons[i].name
          }
        }
      }
    },
    // 绑定sip电话
    bindSip (row) {
      this.rowSip.row = row
      this.sipShow = true
    },
    // 新建登录账号
    addAccount () {
      this.addShow = true
    },
    // 编辑登录账号
    editAccount (row) {
      this.editRow.row = row
      this.editShow = true
    },
    // 删除登录账号
    delAccount (row) {
      let name = row.username
      this.$confirm('此操作将永久删除该登录账号【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          userids: [row.id],
          spid: parseInt(row.spid)
        }
        deleteuser(data).then(res => {
          this.getAccountTable()
          this.$notify({
            title: '成功',
            message: '删除此登录账号成功',
            type: 'success',
            duration: 2000
          })
        }).catch(() => {
          this.$notify.error({
            title: '失败',
            message: '删除此登录账号失败'
          })
        })
      }).catch(() => {})
    },
    changePwd (row) {
      // console.log(row)
      this.editPwdShow = true
      this.pwdForm.spid = parseInt(row.spid)
    },
    commitPwd (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          changepwd(this.pwdForm).then(res => {
            this.editPwdShow = false
            this.$notify({
              title: '成功',
              message: '成功更改账号密码',
              type: 'success',
              duration: 2000
            })
          }).catch(() => {})
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 页码
    handleSizeChange (val) {
      this.pageSize = val
      // this.getPersonPage()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      // this.getPersonPage()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/account.vue